import React from 'react';
import PageHeader from '@/components/Layout/PageHeader';
import { Button, Card, EmptyState, PageSection } from '@/ui/components';
import '@/pages/dataGridFocus.css';

const TemplateList: React.FC = () => {
  return (
    <div className="dgf-page">
      <PageHeader
        title="Document Templates"
        subtitle="Template management will plug into the existing PDF workflows."
        itemCount={0}
        gradientColor="linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)"
        icon="📄"
        searchEnabled={false}
        sortEnabled={false}
      />

      <PageSection width="normal" padding="default">
        <Card>
          <EmptyState
            icon={<span style={{ fontSize: '64px', lineHeight: 1 }}>📋</span>}
            title="Document Templates"
            description="This page will be connected to the existing PDF template system."
            action={<Button variant="secondary">Coming soon</Button>}
          />
        </Card>
      </PageSection>
    </div>
  );
};

export default TemplateList;
